const types = {
  FETCH_PLATE: "FETCH_PLATE",
  FETCH_PERMIT_PLATE: "FETCH_PERMIT_PLATE",
};

export default types;
